import { BaseSlideShowPanel, SlideBase } from "./BaseSlideShowPanel";
import { ObjectBuilder, Image3D, ImgButtonWithText, LayoutUtils, Rectangle3D } from "@dreamcam/babylon-tools";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { Env } from "../../../settings/Env";
import { text } from "../../../TextResources";
import { Settings } from "../../../settings/Settings";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
export class OnboardingSlideShowPanel extends BaseSlideShowPanel {
    async _getSlideTextsAsync() {
        return text.onboarding_slides;
    }
    _getSlideLayouts(slidesCount) {
        const env = Env.lobby.onboarding;
        const result = [];
        for (let i = 0; i < slidesCount; i++) {
            const layout = i === 0
                ? env.firstSlide
                : i === slidesCount - 1
                    ? env.lastSlide
                    : env.slide;
            result.push(layout);
        }
        return result;
    }
    _createSlide(position, totalSlides, layout, content, mesh, func) {
        if (position === 0)
            return new OnboardingFirstSlide(position, totalSlides, layout, content, mesh, func);
        if (position === totalSlides - 1)
            return new OnboardingLastSlide(position, totalSlides, layout, content, mesh, func);
        return new OnboardingSlide(position, totalSlides, layout, content, mesh, func);
    }
    _close() {
        Settings.getInstance().onboarding.wasViewed = true;
        // setTimeout(() => {
        //     if (!Settings.getInstance().streamTypesAnnouncement.wasViewed) {
        //         AppView.getInstance().announcementPanel.show();
        //     }
        // }, 1000);
        super._close();
    }
}
class OnboardingSlideBase extends SlideBase {
    constructor(position, totalSlides, layout, content, mesh, func) {
        super(position, totalSlides, layout, content, mesh, func);
        const layoutText = Object.assign({}, layout.text);
        this.textBlock = ObjectBuilder.createTextBlock3D(mesh, `onboardingText${position}`, content.text, layoutText);
        this.addControl(this.textBlock);
        this.pageTextBlock = ObjectBuilder.createTextBlock3D(mesh, "pagination", `${position + 1} of ${totalSlides}`, Env.lobby.onboarding.page);
        this.addControl(this.pageTextBlock);
    }
}
class OnboardingFirstSlide extends OnboardingSlideBase {
    constructor(position, totalSlides, layout, content, mesh, func) {
        super(position, totalSlides, layout, content, mesh, func);
        const stackPanel = new StackPanel("firstSlideStackPanel");
        stackPanel.isVertical = true;
        stackPanel.verticalAlignment = StackPanel.VERTICAL_ALIGNMENT_TOP;
        stackPanel.topInPixels = mesh.m2px(layout.stackPanel.top);
        stackPanel.spacing = mesh.m2px(layout.stackPanel.spacing);
        this.addControl(stackPanel);
        const logo = new Image3D("onboardingLogo", layout.logo.image);
        logo.leftInPixels = mesh.m2px(layout.logo.left);
        logo.widthInPixels = mesh.m2px(layout.logo.width);
        logo.heightInPixels = mesh.m2px(layout.logo.height);
        logo.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        logo.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        stackPanel.addControl(logo);
        const layoutHeader = Object.assign({}, layout.header);
        stackPanel.addControl(ObjectBuilder.createTextBlock3D(mesh, "onboardingFirstHeader", content.header, layoutHeader));
        stackPanel.addControl(this.textBlock);
        this.AddNextButton();
        this.AddCloseButton();
    }
}
class OnboardingLastSlide extends OnboardingSlideBase {
    constructor(position, totalSlides, layout, content, mesh, func) {
        super(position, totalSlides, layout, content, mesh, func);
        const rectangle = new Rectangle3D(`onboardingSlideImageContainer${position}`);
        rectangle.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        rectangle.topInPixels = this._mesh.m2px(layout.image.top);
        rectangle.heightInPixels = this._mesh.m2px(layout.image.height);
        rectangle.widthInPixels = this._mesh.m2px(layout.image.width);
        rectangle.cornerRadius = this._mesh.m2px(layout.image.radius);
        rectangle.thickness = 0;
        this.addControl(rectangle);
        const image = new Image3D(`onboardingSlideImage${position}`, layout.image.path(position));
        image.heightInPixels = this._mesh.m2px(layout.image.height);
        image.widthInPixels = this._mesh.m2px(layout.image.width);
        image.zIndex = -1;
        rectangle.addControl(image);
        if (layout.extraImages !== undefined) {
            for (const extraImg of layout.extraImages) {
                const img = new Image3D(`onboardingSlideImage${position}ExtraImg`, extraImg.path);
                img.heightInPixels = this._mesh.m2px(extraImg.height);
                img.widthInPixels = this._mesh.m2px(extraImg.width);
                img.leftInPixels = this._mesh.m2px(extraImg.left);
                img.topInPixels = this._mesh.m2px(extraImg.top);
                img.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
                img.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
                this.addControl(img);
            }
        }
        const env = Env.lobby.onboarding;
        const finishButton = new ImgButtonWithText("onboardingButtonFinish", {
            text: text.onboarding_finishButton,
            textLayout: this._mesh.textLayoutM2Px(env.nextButton.textLayout),
            imageLayout: LayoutUtils.GetButtonLayout(env.nextButton.imageLayout, this._mesh),
        });
        finishButton.heightInPixels = this._mesh.m2px(env.nextButton.height + env.nextButton.bottom);
        finishButton.widthInPixels = this._mesh.m2px(env.nextButton.width);
        finishButton.paddingBottomInPixels = this._mesh.m2px(env.nextButton.bottom);
        finishButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        finishButton.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;
        finishButton.onClickObserver.add(() => {
            this._func.close();
        });
        this.addControl(finishButton);
        this.AddBackButton();
        this.AddCloseButton();
    }
}
class OnboardingSlide extends OnboardingSlideBase {
    constructor(position, totalSlides, layout, content, mesh, func) {
        super(position, totalSlides, layout, content, mesh, func);
        const rectangle = new Rectangle3D(`onboardingSlideImageContainer${position}`);
        rectangle.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        rectangle.topInPixels = this._mesh.m2px(layout.image.top);
        rectangle.heightInPixels = this._mesh.m2px(layout.image.height);
        rectangle.widthInPixels = this._mesh.m2px(layout.image.width);
        rectangle.cornerRadius = this._mesh.m2px(layout.image.radius);
        rectangle.thickness = 0;
        this.addControl(rectangle);
        const image = new Image3D(`onboardingSlideImage${position}`, layout.image.path(position));
        image.heightInPixels = this._mesh.m2px(layout.image.height);
        image.widthInPixels = this._mesh.m2px(layout.image.width);
        image.zIndex = -1;
        rectangle.addControl(image);
        if (layout.extraImages !== undefined) {
            for (const extraImg of layout.extraImages) {
                const img = new Image3D(`onboardingSlideImage${position}ExtraImg`, extraImg.path);
                img.heightInPixels = this._mesh.m2px(extraImg.height);
                img.widthInPixels = this._mesh.m2px(extraImg.width);
                img.leftInPixels = this._mesh.m2px(extraImg.left);
                img.topInPixels = this._mesh.m2px(extraImg.top);
                rectangle.addControl(img);
            }
        }
        this.AddBackButton();
        this.AddNextButton();
        this.AddCloseButton();
    }
}
